export default "__VITE_ASSET__CJbkkNvF__"